import apiClient from '@/services/axios'

export async function get(venueDetailsId, year, month) {
  //month (1-12)
  var response = await apiClient.get(process.env.VUE_APP_MARCOM_API_BASE_URL + `/admin/venue-details/booking-percentage/${venueDetailsId}/${year}/${month}`);

  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to get booking percentage');
}
